module.exports = __webpack_public_path__ + "static/media/SN.1569aca0.svg";